import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { useStateContext } from "../../../contexts/ContextProvider";
import { Loader, ButtonModifier } from "../../../components";
import { ShowTableRabPekerjaanFormatted } from "../../../components/ShowTable";
import { postRequest } from "../../../constants/api";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Button,
  Pagination,
  TextField,
  InputAdornment,
  Link,
} from "@mui/material";
import useScreenWidth from "../../../hooks/useScreenWidth";
import { formatDate } from "../../../constants/helper";

const TampilRab = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch, setting } = useContext(AuthContext);
  const [noRab, setNoRab] = useState("");
  const [tanggalDpRab, setTanggalDpRab] = useState("");
  const [arsitek, setArsitek] = useState("");
  const [kodeProyek, setKodeProyek] = useState("");
  const [namaCustomer, setNamaCustomer] = useState("");
  const [linkDokumenRab, setLinkDokumenRab] = useState("");
  const [keteranganRab, setKeteranganRab] = useState("");

  const [rabPekerjaansPagination, setRabPekerjaansPagination] = useState([]);
  const navigate = useNavigate();
  let isEditableManager = user.tipeUser !== "ADMIN";
  // let isEditable = isEditableManager;
  let isEditable = true;

  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(20);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  useEffect(() => {
    getRabById();
  }, [page]);

  const getRabById = async () => {
    setLoading(true);
    const response = await postRequest(`/rabs/${id}`, {}, navigate, dispatch);
    setNoRab(response.data.noRab);
    setTanggalDpRab(formatDate(response.data.tanggalDpRab));
    setArsitek(
      `${response.data.arsitek.kodeArsitek} - ${response.data.arsitek.namaArsitek}`
    );
    setKodeProyek(response.data.proyek.kodeProyek);
    setNamaCustomer(response.data.proyek.customer.namaCustomer);
    setLinkDokumenRab(response.data.linkDokumenRab);
    setKeteranganRab(response.data.keteranganRab);

    const response2 = await postRequest(
      `/rabPekerjaansByRabFormattedTablePagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
      { rabId: response.data.id },
      navigate,
      dispatch
    );
    setRabPekerjaansPagination(response2.data.rabPekerjaans);
    setPage(response2.data.page);
    setPages(response2.data.totalPage);
    setRows(response2.data.totalRows);
    setLoading(false);
  };

  const deleteRab = async (id) => {
    setLoading(true);
    await postRequest(`/deleteRab/${id}`, {}, navigate, dispatch);
    navigate("/daftarRab");
    setLoading(false);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Proyek</h3>
      <h5 style={{ fontWeight: 400 }}>RAB</h5>
      <hr />
      <Button
        variant="outlined"
        color="secondary"
        onClick={() => navigate("/daftarRab")}
        sx={{ marginLeft: 2, marginTop: 4 }}
      >
        {"< Kembali"}
      </Button>

      <Box sx={buttonModifierContainer}>
        {isEditable && user.tipeUser !== "ARSITEK" && (
          <>
            <ButtonModifier
              id={id}
              kode={"test"}
              addLink={`/daftarRab/rab/${id}/tambahRabPekerjaan`}
              editLink={`/daftarRab/rab/${id}/edit`}
              deleteUser={deleteRab}
              nameUser={noRab}
            />
          </>
        )}
      </Box>
      <Form>
        <Card>
          <Card.Header>RAB</Card.Header>
          <Card.Body>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    No. RAB :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control required value={noRab} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tgl. DP RAB :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={tanggalDpRab}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Arsitek :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={arsitek} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Proyek :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      value={`${kodeProyek} - ${namaCustomer}`}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Link Dokumen :
                  </Form.Label>
                  <Col sm="8">
                    <TextField
                      disabled
                      value={linkDokumenRab}
                      defaultValue={linkDokumenRab}
                      variant="outlined"
                      size="small"
                      multiline
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Link href={linkDokumenRab}>Buka Link</Link>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Keterangan :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={keteranganRab}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Form>
      <Box sx={tableContainer}>
        <ShowTableRabPekerjaanFormatted
          page={page}
          limit={limit}
          id={id}
          currentPosts={rabPekerjaansPagination}
        />
      </Box>
      <Box sx={tableContainer}>
        <Pagination
          count={pages}
          page={page + 1}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box>
    </Container>
  );
};

export default TampilRab;

const buttonModifierContainer = {
  mt: 4,
  mb: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const subTitleText = {
  fontWeight: "900",
};
